import React from "react";
const AhtapotTextBox = () => {
    return (<>
            <div style={{padding: 0, margin: 0, color: "#e80000", fontWeight: "bold"}}>
                *** KDV Hariç fiyat bilgisi gösterilmektedir.
            </div>
            <div style={{padding: 0, margin: 0, color: "#e80000", fontWeight: "bold"}}>
                *** 10000'den Fazla Dosyanız Var İse, Size Özel Üyelik Modelinizi Belirlemek İçin
                Müşteri Temsilciniz ile İletişime Geçiniz.
            </div>
        </>
    );
}

export default AhtapotTextBox;


